/**
 * @readonly
 * @typedef {string} incidentImpact
 * @enum {incidentImpact}
 */
export const IncidentImpact = {
    NONE: 'none',
    MAINTENANCE: 'maintenance',
    MINOR: 'minor',
    MAJOR: 'major',
    CRITICAL: 'critical'
}
